//爱心社捐款
<template>
	<div class="pages" v-loading="listLoading">
		<div v-for='(item,index) in templateData.TemplateContent.Controls' :key='index'>
			<Digit v-if='item.Property.Control=="Number"' :data-val='item'></Digit>
			<Contact v-if='item.Property.Control=="Condition"' :data-val="item"></Contact>
			<Dates v-if='item.Property.Control=="Date"' :data-val="item"></Dates>
			<Version v-if='item.Property.Control=="Text"' @child-event='getTextVal' :data-val="item"></Version>
			<Money v-if='item.Property.Control=="Money"' :data-val="item"></Money>
			<Tips v-if='item.Property.Control=="Tips"' :data-val="item"></Tips>
			<File v-if='item.Property.Control=="File"' :data-val="item"></File>
			<Table v-if='item.Property.Control=="Table"' @child-event='tableOperation' :data-val='item' :template-data='templateData'></Table>
			<Selector v-if='item.Property.Control=="Selector"' @child-event='getSelectorVal' :data-val='item'></Selector>
			<Textarea v-if='item.Property.Control=="Textarea"' :data-val='item'></Textarea>
			<Choose v-if='item.Property.Control=="Contact"' @child-event='clickChoose' :data-val='item'></Choose>
			<SelectFilterTable v-if='item.Property.Control=="SelectFilterTable"' @data-val='item' :template-data='templateData.TemplateContent.Controls'
			 :val-index='5'></SelectFilterTable>
		</div>

		<Button class="submit-process" v-on:click='submit' v-bind:disabled="isDisabled" v-bind:loading="formLoading" size="large"
		 type="primary"> 提交
		</Button>
	</div>
</template>

<script>
	/**
	 * Version 为Text文本组件
	 */
	import Digit from '../components/Number.vue'
	import Contact from '../components/Contact.vue';
	import Dates from '../components/Date.vue';
	import Version from '../components/Text.vue';
	import Money from '../components/Money.vue';
	import Tips from '../components/Tips.vue';
	import File from '../components/File.vue';
	import Table from '../components/Table.vue';
	import Selector from '../components/Selector.vue';
	import Textarea from '../components/Textarea.vue';
	import Choose from '../components/Choose.vue';
	import SelectFilterTable from '../components/SelectFilterTable.vue';
	import wx from 'weixin-js-sdk'
	import stringUtils from "../assets/js/stringUtil.js";
	import {
		initWxConfig
	} from '../api/jssdk.js';
	import {
		getTemplateInfo,
		submitProcess,
		getAdministrativeProgressive,
	} from '@/api/approval'
	import {
		getDepartmentInfo,
		getDepartmentRelationByStructs
	} from '@/api/department'
	import {
		getRelation
	} from '@/api/employee'

	var isSubmit = false;

	var template = {
		TemplateContent: {
			Controls: []
		}
	};
	export default {
		components: {
			Contact,
			Dates,
			Version,
			Money,
			Tips,
			File,
			Table,
			Digit,
			Selector,
			Textarea,
			Choose,
			SelectFilterTable
		},
		data() {
			return {
				templateData: template,
				relationList: null,
				logInfo: null,
				templateId: "",
				spNo: null,
				formLoading: false,
				listLoading: false,
				isDisabled: false
			}
		},
		created() {
			initWxConfig(this);

			this.logInfo = this.getLoginUserInfo();
			this.templateId = this.$route.query.templateId;
			this.spNo = this.$route.query.spNo;
			this.getTemplate();
		},
		methods: { //方法


			getTemplate: function() {
				var departs = this.logInfo.fullName;
				var that = this;

				that.$http({
					url: that.$httpUrl.getTemplate + "?templateId=" + that.templateId,
					method: "get",
				}).then(async res => {
					var controls = res.data.Body;
					controls.TemplateContent.Controls.forEach((item) => {
						item.IsShow = true;
						if (item.Property.Title[0].Text == "捐款申请") {
							item.Value = `本人  ` + that.logInfo.EmpName + `      ，身份证号       ` + that.logInfo.IdCard +
								`      ，自愿支持中原公司爱心平台的搭建，促进中原公司爱心行动，充分发挥互助互爱，团队协作精神。自愿从每月工资/合作费中捐出10元（壹拾元）人民币作为爱心基金，用于爱心社活动。在本人及直系亲属遭遇重大变故或疾病时可向爱心社申请资助。`;
						}
						if (item.Property.Title[0].Text == "捐款金额") {
							item.Config.Selector.Options.forEach(e => {
								if (e.Value[0].Text == "10元") {
									item.Value = e.Key;
								}
							});
						}
					})
					this.templateData = this.assignControl(controls, this.logInfo);
					this.templateData = await this.assignControlBySpNo(controls, this.spNo);
					console.log(this.templateData);
				})
			},
			getTextVal() {},
			getSelectorVal(val, name) {
				if (name == "捐款金额") {
					var control = null;
					this.templateData.TemplateContent.Controls.forEach(e => {
						if (e.Property.Title[0].Text == "捐款申请") {
							control = e;
						}
					});
					var money = "10元";
					var chinese = "壹拾元";
					this.templateData.TemplateContent.Controls.forEach((item) => {
						if (item.Property.Title[0].Text == "捐款金额") {
							item.Config.Selector.Options.forEach(e => {
								if (e.Key == item.Value) {
									switch (e.Value[0].Text) {
										case "10元":
											money = "10元";
											chinese = "壹拾元";
											break;
										case "20元":
											money = "20元";
											chinese = "贰拾元";
											break;
										case "30元":
											money = "30元";
											chinese = "叁拾元";
											break;
										case "40元":
											money = "40元";
											chinese = "肆拾元";
											break;
										case "50元":
											money = "50元";
											chinese = "伍拾元";
											break;
										case "100元":
											money = "100元";
											chinese = "壹佰元";
											break;
									}
								}
							});
							control.Value = `本人  ` + this.logInfo.EmpName + `      ，身份证号       ` + this.logInfo.IdCard +
								`      ，自愿支持中原公司爱心平台的搭建，促进中原公司爱心行动，充分发挥互助互爱，团队协作精神。自愿从每月工资/合作费中捐出`+money+`（`+chinese+`）人民币作为爱心基金，用于爱心社活动。在本人及直系亲属遭遇重大变故或疾病时可向爱心社申请资助。`;
						}
					})
				}
			},
			tableOperation(val, type, datas) {
				if (type == 'compute') {
					return;
				}
				this.tableoperation(val, type, datas, this);
			},
			submit: async function() {
				var that = this;
				var IsReturn = false;


				if (isSubmit) {
					this.Message({
						message: '已提交',
						type: 'warning',
						duration: 1000
					});
					return;
				}
				isSubmit = true;
				this.listLoading = true;
				//提交
				submitProcess(this.templateId, this.logInfo.EmpNo, this.spNo, this.templateData).then(response => {
					this.Message({
						message: '申请成功',
						type: 'success',
						duration: 3 * 1000
					});
					setTimeout(() => {
						this.$router.push("/index");
					}, 3000)
				}).finally(() => {
					isSubmit = false;
					this.listLoading = false;
					for (var i = 0; i < this.templateData.TemplateContent.Controls.length; i++) {
						var item = this.templateData.TemplateContent.Controls[i];
						if (item.Property.Title[0].Text == "申请内容") {
							item.Config.Table.Children.forEach(async (sonData) => {
								if (sonData.Property.Title[0].Text == "种类") {
									sonData.Property.Control = "SelectFilterTable";
									sonData.filterable = true;
									sonData.Options = [];
									await getAdministrativeProgressive("", "", "", "", "", "").then(res => {
										res.Body.forEach(item => {
											var data = {
												"Key": item,
												"Value": item
											};
											sonData.Options.push(data);
										});
									});

								}
								if (sonData.Property.Title[0].Text == "物品名称") {
									sonData.Property.Control = "SelectFilterTable";
									sonData.filterable = true;
								}
								if (sonData.Property.Title[0].Text == "规格型号") {
									sonData.Property.Control = "SelectFilterTable";
									sonData.filterable = true;
								}
								if (sonData.Property.Title[0].Text == "单位") {
									sonData.Property.Control = "SelectFilterTable";
									sonData.filterable = true;
								}
								if (sonData.Property.Title[0].Text == "单价") {
									sonData.Property.Control = "SelectFilterTable";
									sonData.filterable = true;
								}
							});
						}
					}

				});
			}
		},
		watch: {
			relationList(val, oldVal) {
				if (oldVal == null) {
					this.getTemplate();
				}
			}
		}
	}
</script>

<style scoped lang="less">
	.pages {
		padding-bottom: 14px;
	}
</style>
